<template>
  <div class="c-number">
    <img :src="img">
  </div>
</template>
<script>
import moment from "@/moment"

export default {
  name: 'SpinNumber',
  props: {
    start: {
      type: Number,
      default: 0
    },
    startShow: {
      type: String,
      default: null
    },
    result: {
      type: String,
      default: null
    },
    sec: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      number: '0',
      Interval: null,
      setTimeout: null
    }
  },
  computed: {
    detectData() {
      return JSON.stringify([this.startShow, this.result])
    },
    img() {
      return require(`@/assets/theme/numbers/${this.number.toString()}.png`)
    }
  },
  watch: {
    detectData() {
      this.stopSpin()
    }
  },
  methods: {
    spinning() {
      let running = this.start
      this.Interval = setInterval(() => {
        running++;
        this.number = running % 10
      }, 100);
    },
    stopSpin() {
      console.log('stopSpin')
      if(this.result && this.startShow) {
        clearTimeout(this.setTimeout)
        let diff = moment(this.startShow).add(this.sec, 'seconds').diff(moment(), 'milliseconds')
        this.setTimeout = setTimeout(() => {
          clearInterval(this.Interval)
          this.number = this.result
        }, diff);
      }
    }
  },
  created() {
    this.spinning()
    this.stopSpin()
  },
  beforeDestroy() {
    clearInterval(this.Interval)
  }
}
</script>
